import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/fahrgestellnummer-pruefen/FahrgestellNummerPruefen.js");
